import { render, staticRenderFns } from "./DevModelModal.vue?vue&type=template&id=c51f9b9c&"
import script from "./DevModelModal.vue?vue&type=script&lang=js&"
export * from "./DevModelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports